import {observer} from "mobx-react";
import * as React from "react";
import {User} from "data/entities/User";
import {generateAvatarURL} from "../../data/entities/IUser";

import './NavAvatar.pcss';

interface Props {
  user: User;
  variant: 'xsmall'|'small'|'medium'|'large'|'xlarge'|'boxy';
  alt?:string;
  style?:any;
}
// 24, 32, 36, 48, 72, 44
/**
 * If this is an avatar for a user who is not the currently logged in user, then it is hidden
 * from screen readers. Otherwise, the existence of the avatar, and what is displayed is communicated
 * to the user.
 *
 */
export const NavAvatar = observer((props: Props) => {
  let avatar = <img aria-hidden alt={""} src="/res_sys/user.png"/>;
  if (props.user) {
    const avatarURL = props.user.avatarURL ? props.user.avatarURL : (props.user.avatar ? generateAvatarURL(props.user.avatar) : '') ;
    if (avatarURL) {
      avatar = <img alt={""} src={avatarURL} />;
    } else {
      let initials = '--';
      if(props.user.nameOrNickname && props.user.nameOrNickname.length>0) {
        const parts = props.user.nameOrNickname.split(' ');
        initials = parts[0].charAt(0);
        if (parts.length > 1) {
          initials += parts[1].charAt(0);
        } else if(parts[0].length>1) {
          initials += parts[0].charAt(1);
        }
      }
      avatar = <span aria-hidden="true">{initials}</span>;
    }
  }
  return <div
      className={`nav-avatar ${props.variant}`}
      aria-hidden={!props.alt}
      aria-label={props.alt}
      style={props.style}>{avatar}</div>
});


